import { KnownApiError } from "@mirage-web/networking/known-api-error";
import { z } from "zod";

const apiErrorSchema = z
  .object({
    code: z.string(),
    message: z.string(),
  })
  .passthrough();

export function getApiError<T extends { code: string; message: string }>(
  error: Error,
  schema: z.ZodType<T> = apiErrorSchema as z.ZodType<T>
) {
  if (error instanceof KnownApiError) {
    if (typeof error.responseObject === "object") {
      const parsed = z.object({ error: schema }).safeParse(error.responseObject);

      if (parsed.success) {
        return parsed.data.error;
      }
    }
  }
}

export function isMissingOasisPermissionError(error: Error) {
  const apiError = getApiError(
    error,
    apiErrorSchema.extend({ permission: z.string(), code: z.literal("missing_oasis_permission") })
  );

  return [apiError?.code === "missing_oasis_permission", apiError?.permission] as const;
}

export function isMissingSessionError(error: Error) {
  const apiError = getApiError(
    error,
    apiErrorSchema.extend({
      code: z.enum(["session_missing", "session_expired", "session_invalid"]),
    })
  );

  return !!apiError;
}

export function isNotFoundError(error: Error) {
  const apiError = getApiError(error, apiErrorSchema.extend({ code: z.literal("not_found") }));

  return apiError?.code === "not_found";
}
